// src/components/Common/Loader.js
import React from 'react';

const Loader = ({ fullScreen = false }) => (
  <div className={`flex justify-center items-center ${fullScreen ? 'min-h-screen' : 'py-12'}`}>
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
);

export default Loader;